import { create } from 'zustand';
import { Venue } from '../../../shared/models';

interface AvailabilityState {
  venue: Venue | null;
  selectedDate: Date | null;
  selectedSection: string;
  numberOfPeople: number;
  openBarSelected: boolean;
  totalPrice: string | null;

  // Actions
  initializeVenue: (venue: Venue | null) => void;
  setSelectedDate: (date: Date | null) => void;
  setSelectedSection: (section: string) => void;
  setNumberOfPeople: (people: number) => void;
  setOpenBarSelected: (selected: boolean) => void;
  setTotalPrice: (price: string | null) => void;
  reset: () => void;
}

export const useAvailabilityStore = create<AvailabilityState>((set) => ({
  venue: null,
  selectedDate: null,
  selectedSection: '',
  numberOfPeople: 1,
  openBarSelected: false,
  totalPrice: null,

  // Actions
  initializeVenue: (venue) => set({
    venue,
    selectedDate: null,
    selectedSection: venue ? Object.keys(venue.Sections)[0] || '' : '',
    numberOfPeople: venue && venue.Sections ? venue.PricingRatesPerSection[Object.keys(venue.Sections)[0]].MinimumPeople : 1,
    openBarSelected: false,
    totalPrice: null
  }),
  setSelectedDate: (date) => set({ selectedDate: date }),
  setSelectedSection: (section) => set({ selectedSection: section }),
  setNumberOfPeople: (people) => set({ numberOfPeople: people }),
  setOpenBarSelected: (selected) => set({ openBarSelected: selected }),
  setTotalPrice: (price) => set({ totalPrice: price }),
  reset: () => set({
    venue: null,
    selectedDate: null,
    selectedSection: '',
    numberOfPeople: 1,
    openBarSelected: false,
    totalPrice: null
  })
}));